import {useBooleanState} from '@wandb/weave/common/util/hooks';
import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {teleportAdminCheckEnabled} from '../../../config';
import {
  registerImpersonateOpener,
  registerRequestAdminAccessOpener,
  registerSimulateUsageOpener,
} from '../../../shellRemote';
import {useViewer} from '../../../state/viewer/hooks';
import {homePage} from '../../../util/urls';
import {ImpersonateUserModal} from '../../ImpersonateUserModal';
import TeleportAccessRequestModal from '../../TeleportAccessRequestModal';
import UsageSimulationModal from '../../UsageSimulationModal';

export function ShellAdminModals() {
  const viewer = useViewer();
  const history = useHistory();
  const {
    state: impersonateModalOpen,
    setTrue: openImpersonateModal,
    setFalse: closeImpersonateModal,
  } = useBooleanState(false);
  const {
    state: usageSimulationModalOpen,
    setTrue: openUsageSimulationModal,
    setFalse: closeUsageSimulationModal,
  } = useBooleanState(false);
  const {
    state: teleportAccessRequestModalOpen,
    setTrue: openTeleportAccessRequestModal,
    setFalse: closeTeleportAccessRequestModal,
  } = useBooleanState(false);

  useEffect(() => {
    if (viewer?.admin !== true) {
      return;
    }
    return registerImpersonateOpener(openImpersonateModal);
  }, [openImpersonateModal, viewer?.admin]);

  useEffect(() => {
    if (viewer?.admin !== true) {
      return;
    }
    return registerSimulateUsageOpener(openUsageSimulationModal);
  }, [openUsageSimulationModal, viewer?.admin]);

  useEffect(() => {
    if (viewer?.admin !== true || !teleportAdminCheckEnabled()) {
      return;
    }
    return registerRequestAdminAccessOpener(openTeleportAccessRequestModal);
  }, [openTeleportAccessRequestModal, viewer?.admin]);

  return (
    <>
      {impersonateModalOpen && (
        <ImpersonateUserModal
          onClose={closeImpersonateModal}
          onImpersonate={() => history.push(homePage())}
          onClick={e => {
            e.stopPropagation();
          }}
        />
      )}
      {usageSimulationModalOpen && (
        <UsageSimulationModal onClose={closeUsageSimulationModal} />
      )}
      {teleportAccessRequestModalOpen && (
        <TeleportAccessRequestModal onClose={closeTeleportAccessRequestModal} />
      )}
    </>
  );
}
